import axios from 'axios';

export default axios.create({
  baseURL: window.appConfig.MAIL_API_URL,
});
